<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-02-22 11:00:59
 * @LastEditors: xzx
 * @LastEditTime: 2021-02-22 11:00:59
-->
<template>
    <div :ref="setRef" style="position: absolute; width: 500px; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
// import 'echarts/theme/tw_dark.js'
import twDark from '../../../public/tw_dark'
import { onMounted, reactive, watchEffect } from "vue";
import messageService from '../../services/message.service'

export default {
    name: "tw-ws-funnel",
    
    setup(props) {
        let myRef;

        const setRef = el => {
            myRef = el;
        }

        let mockJson = reactive({"data":{"series":[{"name":"漏斗图","data":[
                {value: 60, name: '访问'},
                {value: 40, name: '咨询'},
                {value: 20, name: '订单'},
                {value: 80, name: '点击'},
                {value: 100, name: '展现'}
            ]}]}});

        const dataInit = function() {
            if(mockJson && mockJson.data && mockJson.data.series){
                mockJson.data.series.forEach(function(val){
                    val.type = 'funnel';
                })
            }
        }

        const echartInit = () =>{
            echarts.registerTheme('tw_dark', twDark)
            var myChart = echarts.init(myRef, 'tw_dark');
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: props.title
                },
                legend: {
                    show: props.legendShow
                },
                tooltip: {
                    show: true
                },
                series: mockJson.data.series
            };
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }

        onMounted(()=>{
            watchEffect(() => {
                const data = props.data_source && props.data_source.datas

                if (data) {
                    if (data.data && data.data.series) {
                        mockJson = reactive(props.data_source.datas)
                    } else {
                        if (Array.isArray(data) && props.caption_name && props.value_name) {
                            const chartData = { data: { series:[{ name: props.series_name, data: [] }]}}
                            data.forEach(el => {
                                chartData.data.series[0].data.push({
                                    name: el[props.caption_name],
                                    value: el[props.value_name] 
                                })
                            })
                            mockJson = reactive(chartData)
                        } else {
                            messageService.error('漏斗图：请检查【数据源】数据格式');
                            mockJson = reactive({
                                data: {
                                    categories: [],
                                    series: []
                                }
                            })
                        }
                    }
                }
                dataInit()
                echartInit()
            })
        })

        return {
            setRef,
            echartInit
        };

    },
    props: {
        title: String,
        legendShow: {
            type: Boolean,
            default: true
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        series_name: {
            type: String,
            default: '',
        },
        caption_name: {
            type: String,
            default: ''
        },
        value_name: {
            type: String,
            default: ''
        }
    }
  }
</script>

<style>

</style>